import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setWorkspaceLoaded, startNewWorkspace } from '../../../store/workspaceSlice';
import SimpleMap from 'components/pages/map/SimpleMap';
import DefaultLeftSide from 'components/defultSection/leftside';
import WorkspaceButton from "../../pages/workspacebtn/workspacebtn";
import Cmn_Workspace from 'components/cmn_workspace/cmn_workspace';
import SaveWorkspaceModal from 'components/authentication/signup-login/SaveWorkspaceModal';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import { useAutoLoadDefaultWorkspace } from 'components/authentication/signup-login/useAutoLoadDefaultWorkspace';
import { FaRegUserCircle, FaSearch } from "react-icons/fa";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { BASE_URL, CACHED_BASE_URL } from '../../../commonConfig/ApiConfig';
import '../../../assets/scss/cmn.scss';
import axios from 'axios';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CdapDefault = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Authentication and workspace states
  const { isAuthenticated, login } = useAuth();
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [modalMode, setModalMode] = useState('save');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingSaveMode, setPendingSaveMode] = useState(null);

  // Workspace toggle state
  const [showWorkspace, setShowWorkspace] = useState(true);

  // Map states
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [searchText, setSearchText] = useState("");


  // Redux selectors
  const isWorkspaceLoaded = useSelector(state => state.workspace.isWorkspaceLoaded);
  const loadedWorkspaceName = useSelector(state => state.workspace.loadedWorkspaceName);
  const hasUnsavedChanges = useSelector(state => state.workspace.hasUnsavedChanges);
  const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);

  // Load default workspace hook
  useAutoLoadDefaultWorkspace();

  // Fetch GeoJSON when component mounts
  useEffect(() => {
    const fetchGeoJson = async () => {
      try {
        const localPayload = {
          lgd_code: 1000,
          geo_level_code: 1
        };
        const response = await fetch(`${CACHED_BASE_URL}locations/1000?geo_level=1`);
        if (!response.ok) throw new Error('Failed to fetch GeoJSON');
        const data = await response.json();
                  const geo = await axios.get(`${CACHED_BASE_URL}locations/s-geojson`, {
  params: {
    lgd_code: localPayload.lgd_code,
    geo_level_code: localPayload.geo_level_code,
  },
});
        if (data.locations.geojson) {
          setGeoJsonData(data.locations.geojson);
        } else {
          // const geo = await axios.post(`${BASE_URL}locations/geojson`, localPayload);
          // setGeoJsonData(geo.data.geojson);
setGeoJsonData(geo.data.geojson);
        }

        // Set default selectedFeature for India (country level)
        setSelectedFeature({
          lgd_code: 1000,
          geo_level_code: 1,
          name: 'India',
          properties: {
            name: 'India',
            code: 1000,
            geo_level_code: 1
          }
        });
      } catch (err) {
        console.error('GeoJSON fetch error:', err);
      }
    };

    fetchGeoJson();
  }, []);

  const handleRightClick = () => {
    navigate('/location');
  };

  const handleStateClick = (feature) => {
    navigate('/location', {
      state: { selectedStateFeature: feature }
    });
  };

  //search function
  const handleSearch = async () => {
    try {
      const payload = { searchText: searchText };

      // const response = await axios.post(`$(base)searchAll`, payload);
      const response = await axios.post(
        `${BASE_URL}indicators/searchAll`,
        payload
      );

      if (response.data.success) {
        // ✅ navigate only if success
        navigate("/searchlist", { state: { searched: searchText, results: response.data } });
      } else {
        alert(response.data.message || "No results found");
      }
    } catch (error) {
      console.error("Search API Error:", error);
      alert("Something went wrong while searching!");
    }
  };

  // Workspace functionality
  const visualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
  };

  const handleSaveClick = (mode = 'save') => {
    if (!isAuthenticated) {
      setPendingSaveMode(mode);
      setShowAuthModal(true);
      return;
    }

    if (selectedIndicators.length === 0) {
      alert('Please select at least one indicator');
      return;
    }

    setModalMode(mode);
    setShowSaveModal(true);
  };

  const handleLoginSuccess = (response) => {

    const loginData = response.data || response;
    let userData = null;
    let token = null;

    if (loginData && loginData.user) {
      userData = loginData.user;
      token = loginData.token;
    } else {
      userData = {
        name: response.name || response.user?.name || 'User',
        email: response.email || response.user?.email || 'user@example.com'
      };
      token = response.token || response.access_token;
    }

    setShowAuthModal(false);

    if (pendingSaveMode) {
      setTimeout(() => {
        // Double-check authentication before opening save modal
        const token = localStorage.getItem('authToken');
        const userData = localStorage.getItem('userData');

        if (token && userData) {
          setModalMode(pendingSaveMode);
          setShowSaveModal(true);
        } else {
          // If still not authenticated, show error
          alert('Authentication failed. Please try logging in again.');
        }
        setPendingSaveMode(null);
      }, 1000); // Increased delay to ensure auth state is fully updated
    }
  };

  const handleSaveSuccess = (workspaceData) => {
    alert(`Workspace "${workspaceData.name}" saved successfully!`);

    // Always load the saved workspace as current (for both new saves and save as)
    if (workspaceData.id && workspaceData.name) {
      // Add a small delay to ensure the workspace is properly created
      setTimeout(() => {
        // Dispatch action to load the workspace
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
      }, 100);
    }

    setShowSaveModal(false);
  };

  const handleNewWorkspace = () => {
    // Clear all indicators and locations and reset to "My Workspace" state
    dispatch(startNewWorkspace());
  };

  return (
    <>
      <WorkspaceButton
        showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
      />

      <div className="cdap-container">
        {/* Page title and descriptive text above cdap-header */}
        <div className="p-3 text-start">
          <h2 className="mb-3 color-dark-blue">Explore Data</h2>
          <p className="text-center text-md-start color-dark-blue f-14">
            An integrated platform for urban data in India, spanning national, state, district, and city levels, powered by  government datasets with cross-sectoral, spatial, and temporal data visualisation and analysis.
          </p>

          {/* Search bar and button */}
          <div className="input-group mb-3" style={{ maxWidth: '500px' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search Indicators"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ borderColor: '#6c757d' }}
            />
            <button className="btn btn-primary" onClick={handleSearch}>
              <FaSearch />
            </button>
          </div>
        </div>
        <div className="cdap-header">
          <Row className="g-0 w-100">
            <Col xs={6} className="text-center py-2">
              <h6 className='mt-2'>Explore Data by Sector</h6>
            </Col>
            <Col xs={6} className="text-center py-2" onClick={handleRightClick}>
              <h6 className="mt-2 cursor-pointer">Explore Data by Geography</h6>
            </Col>
          </Row>
        </div>

        <div className="cdap-content">
          <div className="cdap-panel">
            <DefaultLeftSide />
          </div>
          <div className="cdap-panel">
            {/* Map instruction text */}
            <Col className="text-center" onClick={handleRightClick}>
              <div style={{ backgroundColor: '#f8f9fa', padding: '8px 8px' }}>
                <p className="text-center small mb-0" style={{ color: '#6c757d', margin: '0' }}>
                  <i className="fas fa-mouse-pointer me-1"></i>
                  Click on the map to explore States / UTs, Districts, and ULGs. Click here to explore National level Data.
                </p>
              </div>
            </Col>
            <SimpleMap
              geoJsonData={geoJsonData}
              selectedFeature={selectedFeature}
              onFeatureSelect={handleStateClick}
            />
            <div style={{ backgroundColor: '#f8f9fa', padding: '8px 8px' }}>
              <p className="text-center small mb-0" style={{ color: '#6c757d', margin: '0' }}>
                Disclaimer: State and district boundaries are sourced from the Survey of India.
                City and Urban Local Government (ULG) geo-coordinates are sourced from the City Finance platform.
                If a ULG’s geo-coordinates are not displayed, it indicates their unavailability on the source platform.
                For some Tier-1 and Tier-2 cities, coordinates—if unavailable—are derived from prominent local landmarks where necessary.</p>
            </div>
          </div>
        </div>

        {/* Workspace Sidebar */}
        {!showWorkspace && (
          <div
            className="position-fixed end-0 bg-white workspace-scroll shadow"
            style={{
              top: '68px',
              width: '420px',
              height: '100vh',
              zIndex: 1050,
              overflowY: 'scroll',
              padding: '0',
              borderLeft: '1px solid #ddd',
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
            }}
          >
            <div className="h-100 border-0">
              <div className="card-header ui-card-header d-flex justify-content-between align-items-center border-0">
                <h5 className="mb-0">
                  <FaRegUserCircle /> &nbsp;
                  {isWorkspaceLoaded ? loadedWorkspaceName : 'My Workspace'}
                  {hasUnsavedChanges && <span className="text-warning ms-2">*</span>}&nbsp;
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="filter-tooltip">
                        <p>Click save to access your work later.</p>
                      </Tooltip>
                    }
                  >
                    <span>
                      <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                    </span>
                  </OverlayTrigger>
                </h5>
                <button
                  className="btn btn-sm btn-outline-dark"
                  onClick={() => setShowWorkspace(true)}
                >
                  <MdOutlineKeyboardDoubleArrowRight />
                </button>
              </div>
              <div className="card-body pt-3 p-2">
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex justify-content-end">
                      <div className="p-1">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => handleSaveClick(isWorkspaceLoaded ? 'update' : 'save')}
                        >
                          <i className={`bi ${isWorkspaceLoaded ? 'bi-arrow-repeat' : 'bi-save'} me-1`}></i>
                          {isWorkspaceLoaded ? 'Update' : 'Save'}
                        </Button>
                      </div>
                      <div className="p-1">
                        <Button variant="outline-primary" className="btn-sm f-14" onClick={() => handleSaveClick('saveAs')}>
                          Save As
                        </Button>
                      </div>
                      <div className="p-1">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={handleNewWorkspace}
                        >
                          <i className="bi bi-plus-circle me-1"></i> New
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <Cmn_Workspace visualize={(inds) => { visualize(inds) }}
                  showWorkspace={showWorkspace}
                  setShowWorkspace={setShowWorkspace} />
              </div>

            </div>
          </div>
        )}

        {/* Save Workspace Modal */}
        <SaveWorkspaceModal
          show={showSaveModal}
          handleClose={() => setShowSaveModal(false)}
          onSave={handleSaveSuccess}
          selectedIndicators={selectedIndicators}
          selectedLocations={selectedMapFeatures}
          allMapFeatures={selectedMapFeatures}
          mode={modalMode}
        />

        <AuthModalHandler
          show={showAuthModal}
          handleClose={() => {
            setShowAuthModal(false);
            setPendingSaveMode(null);
          }}
          initialMode="login"
          onLoginSuccess={handleLoginSuccess}
        />
      </div>
    </>
  );
};

export default CdapDefault;
